import { ApiGetRequest } from "../api-get-request";
import { ApiParameters } from "../api-parameters";

export class GetTicketOwnershipsRequest extends ApiGetRequest
{
    public constructor(webapiBasepath: string)
    {
        super(
            'subscription/get',
            new ApiParameters(),
            null,
            webapiBasepath);
    }
}
